import React from 'react';
import { I18n as I } from 'react-redux-i18n';
import LookupsHelper from 'lib/LookupsHelper';
import { TooltipLink } from 'vdlib';

const getColumns = (regions, taxOffices) => [
  { title: I.t('SV'), field: 'ID', width: 20 },
  {
    title: I.t('TITLE'),
    dataIndex: 'DistinctiveTitle',
    width: 80,
  },
  {
    title: I.t('TAXNUMBER'),
    dataIndex: 'AFM',
    width: 60,
  },
  {
    align: 'center',
    title: I.t('TAXOFFICE'),
    dataIndex: 'TaxOfficeID',
    render: (_, data) =>
      LookupsHelper.getDescription(taxOffices, data.TaxOfficeID),
    width: 60,
  },
  {
    align: 'center',
    title: I.t('REGION'),
    dataIndex: 'RegionID',
    render: (_, data) => LookupsHelper.getDescription(regions, data.RegionID),
    width: 60,
  },
  {
    title: I.t('CITY'),
    dataIndex: 'City',
    width: 60,
  },
  {
    align: 'center',
    title: I.t('PHONE'),
    dataIndex: 'Phone',
    width: 60,
  },
  {
    align: 'center',
    title: I.t('EMAIL'),
    dataIndex: 'Email',
    width: 100,
  },
  {
    align: 'center',
    fixed: 'right',
    key: 'settings',
    render: (_, data) => (
      <div className="cell-fix-wrap">
        <TooltipLink
          to={'/garages/' + data.ID}
          className="blue action-button"
          icon="info-circle"
          text={I.t('MORE')}
        />
      </div>
    ),
    title: '',
    width: 30,
  },
];

export { getColumns };
